<div class="snippet-wrapper">

  <div class="snippet-body">
    <pre class="code-block">
      <code
        [innerHTML]="code">
      </code>
    </pre>
  </div>

</div>